import BugIcon from '@atlaskit/icon/core/bug';
import React from 'react';

export function SvgBug() {
  return <BugIcon label="" testId="ads-refreshed-icon" />;
}
